import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import GlomtLosen from '@/components/GlomtLosen'
import ChangePassword from '@/components/ChangePassword'
// import { HTTP } from '@/backend/client'
// import store from '@/store/modules/appcurrent'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: '/',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/glomtlosen',
      name: 'GlomtLosen',
      component: GlomtLosen
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: ChangePassword
    }
  ]
})

function requireAuth (to, from, next) {
  if (localStorage.bearertoken !== undefined) {
    next()
  }

//   console.log(store.getters.bearertoken)
//   if (to.path.startsWith('/changepassword')) return
//   if (store.getters.bearertoken === undefined && !from.path.startsWith('/login')) {
//     window.location.href = '/login'
//   }
//   if (HTTP.defaults.headers.common['Authorization'] === undefined && store.getters.bearertoken !== undefined) {
//     HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.bearertoken
//   }
//   next()

//   // HTTP.get(store.APIUrl + '/account/checkauthorization')
//   //   .then(response => {
//   //     next()
//   //   })
//   //   .catch(e => {
//   //     window.location.href = '/login'
//   //   })
}



// WEBPACK FOOTER //
// ./src/router/index.js